import React, { FC } from 'react';
import classNames from 'classnames';
import { NEW_TAB_ATTRIBUTES } from 'src/common/constants';
import getClassName from 'src/common/utils/getClassName';
import IconPictogram from 'src/common/components/IconPictogram';
import styles from './Address.module.scss';

export type AddressProps = {
  title?: string;
  iconColor?: 'green' | 'blue';
  leftAligned?: boolean;
  size?: 'body-m' | 'body-s';
  address?: string;
  city?: string;
  state?: string;
  zip?: string;
  country?: string;
  latitude?: number;
  longitude?: number;
  withMapLink?: boolean;
  sameAddress?: boolean;
};

const Address: FC<AddressProps> = ({
  title,
  iconColor = 'blue',
  leftAligned = false,
  size = 'body-m',
  address,
  city,
  state,
  zip,
  country,
  latitude,
  longitude,
  withMapLink = false,
  sameAddress = false,
}) => {
  if (!address) return null;

  const addressLine1 = address;
  const addressLine2 = [city, state, zip].filter(Boolean).join(', ');
  const addressLine3 = country;

  const mapUrl = latitude && longitude
    ? `https://www.google.com/maps?q=${latitude},${longitude}` : null;

  const addressContent = sameAddress
    ? (
      <span>
        Same as Street Address
      </span>
    ) : (
      <>
        {addressLine1 && <div>{addressLine1}</div>}
        {addressLine2 && <div>{addressLine2}</div>}
      </>
    );

  return (
    <div>
      <div className={styles.titleContainer}>
        <IconPictogram
          id={`static-map-pin-${iconColor}`}
          size="m"
        />
        <p className={styles.title}>
          {title}
        </p>
      </div>
      <address className={getClassName(styles, 'addressContainer', classNames(size, {
        leftAligned,
      }))}
      >
        {withMapLink && mapUrl ? (
          <a href={mapUrl} {...NEW_TAB_ATTRIBUTES} className={styles.addressLink}>
            {addressContent}
          </a>
        ) : (
          addressContent
        )}
        {!sameAddress && addressLine3 && <div>{addressLine3}</div>}
      </address>
    </div>
  );
};

export default Address;
